import { ReactElement, useEffect, useState } from 'react';

import { BannerImage } from '../components/BannerImage';
import { UpdateDepFormSection } from '../components/HirePlanForm/ServidorGDF/UpdateDepFormSection';
import { HirePlanMobileArticleHeader } from '../components/HirePlanForm/mobile/HirePlanMobileArticleHeader';
import { PurchaseSummary } from '../components/HirePlanForm/PurchaseSummaryGdf';
import { PageHelmet } from '../components/PageHelmet';
import { useWindowSizeStore } from '../stores/useWindowSizeStore';
import {
  json,
  useLoaderData,
  useParams,
  useRouteLoaderData,
} from 'react-router-dom';
import { useBoostedPlanDataStore } from '../stores/useBoostedPlanDataStore';
import { useNortheastPlanDataStore } from '../stores/useNortheastPlanDataStore';

export function UpdateDependentGDFPage(): ReactElement {
  /* const GDFPlanData: any = useRouteLoaderData('token-servidor');

  const initialPlanData = GDFPlanData;
  const boostedPlanData = useBoostedPlanDataStore(state => state.data);
  const northeastPlanData = useNortheastPlanDataStore(state => state.data);
  

  const [data, setData] = useState(initialPlanData);

  useEffect(() => {
    console.log(Object.keys(boostedPlanData).length === 0);
    if (Object.keys(boostedPlanData).length !== 0 && boostedPlanData != data) {
      setData(boostedPlanData);
    } else if (
      Object.keys(northeastPlanData).length !== 0 &&
      northeastPlanData != data
    ) {
      setData(northeastPlanData);
      console.log(data);
    }
  }, [boostedPlanData, northeastPlanData]); */
  const width = useWindowSizeStore(state => state.width);

  return (
    <div className="overflow-hidden">
      <PageHelmet title="Incluir Dependentes | OdontoGroup" />

      <BannerImage page="plan" imgSource="/assets/images/plan-banner.jpg" />
      <div className="">
        <article className="-mb-20 bg-transparent min-[748px]:-mt-[326px] -mt-[57px] max-w-[1551px] max-[1599px]:px-6 mx-auto">
          <div className="flex 2xl:gap-16 min-[748px]:gap-8 gap-16 max-[1085px]:flex-col">
            <HirePlanMobileArticleHeader />
            <UpdateDepFormSection key="hirePlanFormSection" />
          </div>
        </article>
      </div>
    </div>
  );
}
